import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalService } from '../global/global.service';
import { DocPack, DocumentCollection } from 'src/app/model/doc_pack';
import { CookieService } from 'ngx-cookie-service';
import { AppService } from '../app/app.service';
const headers = new HttpHeaders()
  .set("Auth-Key", "ba989509ad560f3ee2427ed27fa86a5d")
  .set("Client-Service", "univate-training");
@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  private url = GlobalService.serverURL + 'company/';
  // private url = 'https://univate.ie/demo/api/'
  public userInfo: any = {};
  private companyId!: string;
  constructor(private http: HttpClient, private cookieService: CookieService, private appService: AppService) {
    this.checkUserType()
  }
  ngOnInit() {
    this.checkUserType()
  }

  checkUserType() {
    if (this.cookieService.get('user_id')) {
      this.companyId = this.cookieService.get('company_id')
    }
    else {
      // let obj = JSON.parse(this.appService.getData('training-portal.userInfo'))
      // this.companyId = obj.company_id;
      let trainingPortalData = this.appService.getData('training-portal.userInfo');
      // this.companyId = '93';// keep static for now 
      if (trainingPortalData) {
        try {
          let obj = JSON.parse(trainingPortalData);
          this.companyId = obj.company_id;  
        } catch (error) {
          console.error("Failed to parse user info:", error);
        }
      } else {
        console.warn("No user data found in local storage.");
      }
    }
  }
  contractDocumentList(data) {
    return this.http.post(this.url + 'contract_document',data, { headers })
  }
  viewSignedContract(data) {
    return this.http.post(this.url + 'contract_document/view_signed_contract', data, { headers })
  }
  deleteContractDoc(data) {
    data["company_id"] = this.companyId
    return this.http.post(this.url + 'contract_document/delete',data, { headers })
  }
  usefulDocumentList(data) {
    return this.http.post(this.url + 'useful_document/listing', data, { headers })
  }
  addUsefulDoc(data: FormData) {
    data.append("company_id", this.companyId)
    return this.http.post(this.url + 'useful_document/upload_document', data, { headers })
  }
  getAllUserListing() {
    return this.http.get(this.url + 'useful_document/all_user_listing?co_i=' + this.companyId, { headers })
  }
  deleteUsefulDocument(id) {
    return this.http.get(this.url + 'useful_document/delete_document?doc_i=' + id + '&co_i=' + this.companyId, { headers })
  }
  addDocPack(data: DocumentCollection) {
    data["company_id"] = this.companyId
    return this.http.post(this.url + 'new_document/new_pack', data, { headers })
  }
  editDocPack(data: DocumentCollection) {
    data["company_id"] = this.companyId
    return this.http.post(this.url + 'new_document/edit_pack', data, { headers })
  }
  getPackList(id: string) {
    return this.http.get(this.url + 'new_document/get_pack_list?company_id=' + id, { headers })
  }
  getAllPackDoc(data) {
    data["company_id"] = this.companyId
    return this.http.post(this.url + 'new_document/get_list', data, { headers })
  }
  getPackDetail(id) {
    return this.http.get(this.url + 'new_document/edit_document_pack_list?pack_id=' + id + '&company_id=' + this.companyId, { headers })
  }
  addDoc(data: Document) {
    data["company_id"] = this.companyId
    return this.http.post(this.url + 'new_document/doc_pack', data, { headers })
  }
  empUploadDocument(data: FormData) {
    data.append("company_id", this.companyId)
    return this.http.post(this.url + 'new_document/cmp_upload_doc', data, { headers })
  }
  deletePack(data) {
    data["company_id"] = this.companyId
    return this.http.post(this.url + 'new_document/remove_new_pack', data, { headers })
  }
  deleteDocument(data) {
    data["company_id"] = this.companyId
    return this.http.post(this.url + 'new_document/remove_doc_pack', data, { headers })
  }
  getEmpList(data) {
    return this.http.post(this.url + 'work_documents/employee_listing', data, { headers })
  }
  getEmpCourseWork(f_id: string, e_id: string) {
    return this.http.get(this.url + 'work_documents/listing?folder_id=' + f_id + '&employee_id=' + e_id + '&company_id=' + this.companyId, { headers })
  }
  addContract(data: any) {
    data["company_id"] = this.companyId
    return this.http.post<any>(this.url + 'contract_document/add_contract', data, { headers })
  }
  
  deleteCourseWorkDoc(id: string) {
    return this.http.get(this.url + 'work_documents/remove?id=' + id + '&company_id=' + this.companyId, { headers })
  }
  
  // delete

}